import '../Pages.scss';
import React, { FunctionComponent, useEffect } from 'react';
import ErrorPage from '@justgiving/error-page';
import { loadClient } from '@justgiving/chrome';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';

export type ErrorPageWrapperProps = {
  status?: number;
  messageKey?: string;
};

const ErrorPageWrapper: FunctionComponent<ErrorPageWrapperProps> = ({
  status = 500,
  messageKey = 'page.error500',
}) => {
  const { t } = useTranslation('common', { useSuspense: false });
  useEffect(() => {
    loadClient({
      headerVariant: 'consumer',
      footerVariant: 'full',
    });
  }, []);

  const getErrorPageTranslation = (key: string) => {
    switch (key) {
      case `page.error404`: {
        return {
          message: t('page.error404.heading'),
          subMessage: t('page.error404.message'),
          description: t('page.error404.description'),
          link: t('page.error404.linkWording'),
        };
      }
      case `page.error500`: {
        return {
          message: t('page.error500.heading'),
          subMessage: t('page.error500.message'),
          description: t('page.error500.description'),
          link: t('page.error500.linkWording'),
        };
      }
      case `page.error410`: {
        return {
          message: t('page.error410.heading'),
          subMessage: t('page.error410.message'),
          description: t('page.error410.description'),
          link: t('page.error410.linkWording'),
          redirectUrl:
            'https://help.justgiving.com/hc/en-us/requests/new?preview_as_role=anonymous&ticket_form_id=137829',
        };
      }
      default: {
        return {
          message: t('page.errorGeneric.heading'),
          subMessage: t('page.errorGeneric.message'),
          description: t('page.errorGeneric.description'),
          link: t('page.errorGeneric.linkWording'),
        };
      }
    }
  };

  const strings = {
    fourHundred: {
      message: getErrorPageTranslation(messageKey).message,
      subMessage: getErrorPageTranslation(messageKey).subMessage,
    },
    fiveHundred: {
      message: getErrorPageTranslation(messageKey).message,
      subMessage: getErrorPageTranslation(messageKey).subMessage,
    },
    redirectLabel: getErrorPageTranslation(messageKey).link,
    redirectUrl: getErrorPageTranslation(messageKey).redirectUrl,
  };

  return (
    <>
      <Helmet title={t('page.error.title')} />
      <div data-qa="app" className="jg-pages-container">
        <div className="jg-pages-errorcontent jg-space-phmd@lg jg-space-pvmd">
          <ErrorPage
            errorMessage={getErrorPageTranslation(messageKey).description}
            status={status}
            strings={strings}
          />
        </div>
      </div>
    </>
  );
};

export default ErrorPageWrapper;
